// extracted by mini-css-extract-plugin
module.exports = {"SaleDetailsForm":"SaleDetailsForm_SaleDetailsForm__13NHZ","hotelInfo":"SaleDetailsForm_hotelInfo__3kdWq"};